
<template>
  <v-form ref="form" :readonly="readonly">
    <v-row>
      <v-col cols="12" md="12" class="pb-0">
        <v-text-field v-model="client_portfolio.name" label="Nome do Carteira de Clientes" prepend-icon="mdi-clipboard-list" :readonly="readonly" :rules="required"></v-text-field>
      </v-col>
      <v-col cols="12" md="12" class="d-flex py-0 justify-center">
        <v-radio-group row v-model='client_portfolio.kind'>
          <v-radio :value="'manual'">
            <template v-slot:label>
              <div class="d-flex align-center">
                <span>Manual</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" color="" small icon>
                      <v-icon small>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Os clientes são adicionados APENAS de forma manual.</span>
                </v-tooltip>
              </div>
            </template>
          </v-radio>
          <v-radio :value="'automatic'">
            <template v-slot:label>
              <div class="d-flex align-center">
                <span>Automático</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" color="" small icon>
                      <v-icon small>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Os novos e já cadastrados clientes dos MÓDULOS SELECIONADOS entram automaticamente à esta carteira. Também podem ser adicionados de forma manual.</span>
                </v-tooltip>
              </div>
            </template>
          </v-radio>

          <v-radio :value="'activity'" v-if="client_portfolio.kind == 'activity'">
            <template v-slot:label>
              <div class="d-flex align-center">
                <span>Atividade</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" color="" small icon>
                      <v-icon small>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Os clientes são transferidos entre carteiras por atividade.</span>
                </v-tooltip>
              </div>
            </template>
          </v-radio>

        </v-radio-group>
      </v-col>
      <v-col cols="12" md="12" class="ma-0" v-if="client_portfolio.kind == 'automatic'">
        <v-divider></v-divider>
        <div class="mt-1">
          <span v-if="!readonly" class="subtitle-1">Você selecionou <b>Automático</b>, selecione os módulos automáticos:</span> 
          <span v-if="readonly" class="subtitle-1"><b>Automático</b> nos módulos:</span> 
          <!-- <EditSolutions :readonly="readonly" @newModules="handleNewModules" :model_modality_ids="client_portfolio.module_ids" without_actions /> -->
          <SelectModality multiple :object_with_model="client_portfolio" model="module_ids" :readonly="readonly" :index_by_current_user="false"/>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
import validations from '@/mixins/validations.js'

export default {
  name: 'ClientsPortfolioInfoForm',
  mixins: [ validations ],
  components:{
    SelectModality: () => import('@/components/shared/SelectModality.vue'),
  },
  props:{
    client_portfolio:{
      required: true,
      type: Object,
    },
    readonly:{
      type: Boolean,
      default: false,
    }
  },
  methods:{
    validate(){
      return this.$refs.form.validate()
    },
    handleNewModules(module_ids){
      this.client_portfolio.module_ids = [...module_ids]
    }
  },
  watch:{
    "client_portfolio.kind"(nv){
      if(nv == 'manual'){
        this.client_portfolio.module_ids = []
      }
    }
  }
}
</script>
